<div class='checkpoint'>

  <div class='col-6'>
    @if (namedLocationLabel()) {
      <div class='col-12 mt-sm'>
        <span class='fw-medium'>@if (namedLocationCode()) {{{ namedLocationCode() }} - }{{ namedLocationLabel() }}</span>
      </div>
    }
    <div class='col-12 mb-sm'>
      <span>{{ this.location() }}</span>
    </div>
    @if (timeWindowStart(); as twStart) {
      <div class='col-12'>
        <span class='bold gray pr-sm'>{{ twStart.dateTime | wellDate:'YYYY-MM-DD': twStart.timezone }}</span>
        <span>{{ twStart.dateTime | wellDate:'HH:mm': twStart.timezone }}</span>
        @if (timeWindowEnd(); as twEnd) {
          <span> - </span>
          <span class='bold gray pr-sm'>{{ twEnd.dateTime | wellDate:'YYYY-MM-DD': twEnd.timezone }}</span>
          <span>{{ twEnd.dateTime | wellDate:'HH:mm': twEnd.timezone }}</span>
        }
      </div>
      <div class='col-12'>
        <span>{{ twStart.timezone }}</span>
      </div>
    }
  </div>


</div>


